/**
 * The `cancelStream` frame. It carries the runtime ARN like `sendMessage` does: a cancel can reach
 * a bridge Lambda that no longer holds the run (it detached, or another instance handles the
 * cancel), and that Lambda resolves the runtime to stop from this field, defaulting otherwise.
 */
export interface CancelStreamArgs {
  messageId: string
  sessionId: string
  conversationId: string
  timestamp: string
  bedrockRuntimeArn?: string
}

export function buildCancelStreamPayload(args: CancelStreamArgs): Record<string, string> {
  const payload: Record<string, string> = {
    action: 'cancelStream',
    messageId: args.messageId,
    sessionId: args.sessionId,
    conversationId: args.conversationId,
    timestamp: args.timestamp,
  }
  if (args.bedrockRuntimeArn) payload.bedrock_runtime_arn = args.bedrockRuntimeArn
  return payload
}
